const ExperienceData = [
  {
    title: "Undergraduate TA",
    time: "Sept 2021 - Dec 2021",
    company: "University of Waterloo",
  },

  {
    title: "Web Developer and Design",
    time: "Jan 2022 - Apr 2022",
    company: "Ministry of Government and Consumer Services",
  },
  {
    title: "Data Scientist",
    time: "Sept 2022 - Sept 2023",
    company: "Environment and Climate Change Canada",
  },
  {
    title: "Data Science Researcher",
    time: "Jan 2024 - Current",
    company: "University of Waterloo",
  },
];

export default ExperienceData;
